import React, { useEffect, useRef, useState } from 'react';

const PannellumViewer = ({ data, product }) => {
  const viewerRef = useRef(null);
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/pannellum@2.5.6/build/pannellum.js';
    script.onload = () => {
      window.pannellum.viewer(viewerRef.current.id, {
        type: 'equirectangular',
        panorama: data.image,
        autoLoad: true,
        pitch: 10,
        yaw: 180,
        hfov: 110,
        showControls: true,
        autoRotate: -3,
      });
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [data.image]);

  return (
    <>
      <div className="flex flex-col items-center justify-center bg-[#D3CEC6] overflow-hidden">
        <div className="my-6">
          <img src={data?.darkLogo || data.logo} alt="Company Logo" className="w-full h-[55px]" />
        </div>

        <div className="mb-8">
          <img
            src={product.cover_photo}
            alt="Cover Photo"
            className="w-[250px] h-[500px] object-cover"
          />
        </div>

        {/* Product Details */}
        <div className="mb-8">
          <table className="table-auto w-full border text-[20px]">
            <tbody>
              <tr>
                <td className="p-3 border border-black font-bold">Design Name</td>
                <td className="p-3 border border-black">{product.name}</td>
              </tr>
              <tr>
                <td className="p-3 border border-black font-bold">Size</td>
                <td className="p-3 border border-black">{data.size.size}</td>
              </tr>
              <tr>
                <td className="p-3 border border-black font-bold">Surface</td>
                <td className="p-3 border border-black">{data.finish.name}</td>
              </tr>
              <tr>
                <td className="p-3 border border-black font-bold">Random Faces</td>
                <td className="p-3 border border-black">{product.randoms.length}</td>
              </tr>
            </tbody>
          </table>
        </div>


        {/* Random Photos */}
        <div className="grid grid-cols-2 gap-4 mb-8">
          {product.randoms.slice(0, 4).map((randomImg, index) => (
            <img
              key={index}
              src={randomImg}
              alt={`Random Face ${index + 1}`}
              className="w-[250px] h-[500px] object-cover"
            />
          ))}
        </div>
        <div className="pannellum-container w-full lg:w-[1100px] md:w-[700px] sm:w-full flex mb-6" style={{ position: 'relative' }}>
          <div
            id="panorama"
            ref={viewerRef}
            style={{
              width: `${dimensions.width}px`,
              height: `${dimensions.height}px`,
              margin: '0 auto',
            }}
          ></div>
          <div
            style={{
              position: 'absolute',
              bottom: '10px',
              left: '10px',
              color: '#fff',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              padding: '5px 10px',
              borderRadius: '5px',
              fontSize: '14px',
            }}
          >
            Design & Developed By: Wolf Studio
          </div>

          <div
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
            }}
          >
            <img
              src={data.logo}
              alt="Logo"
              style={{
                width: '80px',
                height: 'auto',
              }}
            />
          </div>
        </div>

        <div className="my-2">
          <img src="/ftr_360.png" alt="360" className="w-full h-[85px]" />
        </div>
      </div>
    </>
  );
};

export default PannellumViewer;
